/**
 * Created by m.igrachev on 7/20/2017.
 */
import standardValidate from "./standardValidate";
import validateWithExpression from "./validateWithExpression";
import decimalValidate from "./isDecimal";
import createValidationMethod from "./validation-method-factory/createValidationMethod";

import isAlpha from "./isAlpha";
import isAlphanumeric from "./isAlphanumeric";
import isDecimal from "./isDecimal";
import isEmail from "./isEmail";
import requiredValidate from "./requiredValidate";
import maxSize from "./maxSize";
import minSize from "./minSize";
import isInRange from "./isInRange";
import isLowercase from "./isLowercase";
import isUppercase from "./isUppercase";
import isNumeric from "./isNumeric";
import isIBAN from "./isIBAN";
import isDateInRange from "./isDateInRange";
import fileExtension from "./fileExtension";
import maxCount from "./maxCount";

export default {
    standardValidate,
    validateWithExpression,
    decimalValidate,
    createValidationMethod,
    isAlpha,
    isAlphanumeric,
    isDecimal,
    isEmail,
    requiredValidate,
    maxSize,
    minSize,
    isInRange,
    isLowercase,
    isUppercase,
    isNumeric,
    isIBAN,
    isDateInRange,
    fileExtension,
    maxCount
};
